import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import { IUser } from '../models/api/User'

// Configure request setup
const serviceName = 'UsersService'
const host = servicesConfig.Users
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const UsersService = {
  search: (
    companyId: string,
    skip?: number,
    limit?: number,
    query?: string,
    role?: 'admin' | 'user',
    type?: 'agency' | 'account',
    locationId?: string
  ) =>
    request()
      .get('/search', {
        params: {
          companyId,
          query,
          role,
          type,
          locationId,
          limit,
          skip,
        },
      })
      .then(responseBody),

  delete: (userId: string) => {
    if (!userId) throw new Error('Invalid User ID')
    return request().delete(`/${userId}`).then(responseBody)
  },

  update: (userId: string, body: IUser) => {
    if (!userId) throw new Error('Invalid User ID')
    return request().put(`/${userId}`, body).then(responseBody)
  },

  create: (body: IUser) => request().post(`/`, body).then(responseBody),

  /**
   * @deprecated Use search() method with locationId parameter instead, or use getAllUsersByLocationId() helper
   * This endpoint returns all users at once and causes performance issues (high latency, pod restarts, OOM)
   *
   * Migration example:
   * // Old:
   * const { users } = await UsersService.getByLocationId(locationId)
   *
   * // New (using helper):
   * import { getAllUsersByLocationId } from './UsersServiceHelpers'
   * const { users, count } = await getAllUsersByLocationId(locationId, companyId)
   *
   * // New (direct search):
   * const { users, count } = await UsersService.search(companyId, 0, 500, undefined, undefined, undefined, locationId)
   */
  getByLocationId: (locationId: string) => request().get(`/?locationId=${locationId}`).then(responseBody),

  read: (userId: string) => {
    if (!userId) throw new Error('Invalid User ID')
    return request().get(`/${userId}`).then(responseBody)
  },

  validatePassword: (body: { userId: string; password: string }) =>
    request().post('/validatePassword', body).then(responseBody),
}

export default UsersService
